export default {
  select: "Choose",
  yes: "Yes",
  no: "No",
  name: "Name",
  loading: "Loading",
  size: "Size",
  accept: "Accept",
  created: "Created",
  search: "Search...",
  noResults: "No results had been found.",
  searchLimit: "text should be more than 3 symbol",
  everywhere: "Everywhere",
  emptyFolder: "The folder is empty!",
  onSelectedFolder: "On selected folder",
  selectFolderWarn: "Please select folder to view!",
};
